import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import React from "react";

export const AdminApolloClient = React.createContext(
  {} as ApolloClient<NormalizedCacheObject>
);
